// extracted by mini-css-extract-plugin
export default {"container":"aLKHLk","container--inline":"rlUfNl","error":"wGOqrf","warning":"zZffRm","icon":"kQiKLj"};